import { useCallback } from 'react';
import { SxProps } from '@mui/material';

import { useMytaverseEvent } from '../../../providers';
import {
  useNotification,
  getErrorNotification,
} from '../../../../../components/Notification';
import { IXRHrBrandTypes } from '../../../../../interfaces/profile';

import EmiratesGoldenTicketBackground from '../../../../../public/images/ek/tickets/emirates-ticket.png';
import DnataGoldenTicketBackground from '../../../../../public/images/ek/tickets/dnata-ticket.png';
import MarhabaGoldenTicketBackground from '../../../../../public/images/ek/tickets/marhaba-ticket.png';
import { downloadGoldenTicket } from '../../../../../helpers/screenshotCanvas';
import { useTranslation } from 'react-i18next';
import ParticipantsService from '../../../../../services/ParticipantsService';
import { restoringFocusDownload } from '../../../../../helpers/screenshotCanvas';

const useGoldenTicket = () => {
  const { goldenTicketRef } = useMytaverseEvent();
  const { showNotification } = useNotification();
  const { t: translate } = useTranslation('common');

  const getTicketDate = useCallback(
    (userBrand: string): [string, SxProps, SxProps] => {
      let ticket = EmiratesGoldenTicketBackground;

      let mainTextPosition = { top: 166, left: 260 };
      let secondaryTextPosition = { top: 201, left: 1315 };

      switch (userBrand) {
        case IXRHrBrandTypes.Ekas:
        case IXRHrBrandTypes.CC:
          ticket = EmiratesGoldenTicketBackground;
          break;
        case IXRHrBrandTypes.Dnata:
          ticket = DnataGoldenTicketBackground;
          mainTextPosition = { top: 182, left: 100 };

          break;
        case IXRHrBrandTypes.Marhaba:
          ticket = MarhabaGoldenTicketBackground;
          mainTextPosition = { top: 182, left: 100 };

          break;
      }

      return [ticket, mainTextPosition, secondaryTextPosition];
    },
    [],
  );

  const downloadTicket = useCallback(async () => {
    if (!goldenTicketRef.current) {
      return;
    }

    goldenTicketRef.current.style.scale = '1';
    try {
      await downloadGoldenTicket(goldenTicketRef);
    } catch (error) {
      showNotification(
        getErrorNotification({
          message: translate('notifications.download.goldenTicketError'),
        }),
      );
    }
    goldenTicketRef.current.style.scale = '0';
  }, []);

  const downloadBackendTicket = useCallback(async () => {
    try {
      const response = await ParticipantsService.getParticipantGoldenTicket();

      const blob = new Blob([response.data], { type: 'image/png' });
      const imageUrl = URL.createObjectURL(blob);

      restoringFocusDownload(imageUrl, 'golden-ticket.png');
    } catch (error) {
      console.log('error', error);
      showNotification(
        getErrorNotification({
          message: translate('notifications.download.goldenTicketError'),
        }),
      );
    }
  }, []);

  return { getTicketDate, downloadTicket, downloadBackendTicket };
};

export default useGoldenTicket;
